import { DOCUMENT, inject } from '@angular/core';

/**
 * The locale this build is, read from `<html lang>`.
 *
 * The build sets that attribute, so it is the one source that cannot drift
 * from the bundle the reader is running. Server-side it is already correct in
 * the prerendered document, so there is no platform check here.
 */
export function currentLocale(): string {
  const lang = inject(DOCUMENT).documentElement.lang;
  return lang || 'en';
}
